/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://khypbnlwcfartdvqamxa7rrrfy.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4xmniuua7ncwnoeroqdxj7ckwa",
    "aws_cognito_identity_pool_id": "us-west-2:88d3ebc0-3aac-4a90-ab62-d9c4323c2769",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_MV1uVtUct",
    "aws_user_pools_web_client_id": "41ufs9l18prj370rbnnoe8bi9n",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "dynamoLensList-dev",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
